// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "elainne-ourives-719e7.firebaseapp.com",
  "projectId": "elainne-ourives-719e7",
  "storageBucket": "elainne-ourives-719e7.appspot.com",
  "messagingSenderId": "876474502280",
  "appId": "1:876474502280:web:45d25da9535f25f95fe33d",
  "measurementId": "G-LDZGJRHKBG",
  "apiKey": "AIzaSyDye9KxJ9QRmh47Xa_XIUmPYkJn5BgxT5Q"
};
